import React, { memo, Fragment } from "react";
import axios from 'axios';
import { useRecoilState, useRecoilValue } from "recoil";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { postState } from '../../../store/postState';

console.log("ArchiveInfo");
export const ArchiveInfo = memo(() => {
  const [postData, setPostData] = useRecoilState(postState);

  const notify = (type, message) => {
    if (type === "success") {
      toast.success(message, {
        hideProgressBar: true
      });
    } else {
      toast.error(message, {
        hideProgressBar: true
      });
    }
  }

  const getPosts = async () => {
    // axios csrfToken
    const csrfToken = document.querySelector('[name=csrf-token]').content
    axios.defaults.headers.common['X-CSRF-Token'] = csrfToken

    const res = await axios.get(`/api/v1/posts`)
                .then(resp => {
                  console.log("get Post Archive success");
                  console.log(resp.data);
                  setPostData(resp.data);
                  notify("success", "投稿を再読み込みしました");
                })
                .catch(e => {
                  console.log("get Post Archive error");
                  // console.log(e.response);
                  notify("error", "Post get Error!");
                });
    return res;
  }

  // 最新投稿の更新取得
  const onClickReloadPost = () =>  getPosts();

  return (
    <>
      <div className="clearfix">
        <div className="float-end">
          <button className="btn btn-warning" onClick={onClickReloadPost} disabled={(!postData.length > 0)}>
            <i className="fas fa-sync-alt" /> 
          </button>
        </div>
      </div>
      {postData.length > 0 ?
        <Fragment>
          {postData.map(item => 
            <dl className="row mb-0" key={item.id}>
              <dt className="col-md-3 col-lg-2 col-xl-2 col-xxl-2">{item.created_at}</dt>
              <dd className="col"><a href={`/agent/hospitals/${item.hospital_id}/edit`}>{item.hospital_name}</a> {item.content}（{item.staff_name}）</dd>
            </dl>
          )}
        </Fragment>
      :
        <div>現在、投稿がありません。</div>
      }
    </>
  );
});
